<template>
    <div class="social-security-page">
      <div class="btn-group">
        <el-button type="primary" icon="el-icon-plus" size="small" @click="openDrawer()">个人社保代缴申请</el-button>
<!--        <el-button type="primary" icon="el-icon-folder-opened" size="small" :disabled="true" title="暂不支持批量导入" @click="alert('暂不支持批量导入')">批量导入</el-button>-->
      </div>
      <div class="tips">
        <el-collapse v-model="activeNames" @change="handleChange">
          <el-collapse-item name="1">
            <template slot="title">
              <div class="coll-title">参保流程</div>
            </template>
            <div class="tip-item">1、 在本表格内完整、准确填写参保人相关信息</div>
            <div class="tip-item">2、 支付订单，订单审核通过后我们将联系您并启动相关服务</div>
            <div class="tip-item">3、 数据流转，我们将对接社保公积金中心为您申报</div>
            <div class="tip-item">4、 社保公积金中心审核信息</div>
            <div class="tip-item">5、 社保公积金中心数据回弹出账单</div>
            <div class="tip-item">6、 划账至社保公积金中心（缴纳费用自行承担）</div>
            <div class="tip-item">7、 社保公积金中心划账至个人社保账户</div>
            <div class="tip-item">8、 参保成功，个人可查询到缴纳信息</div>
          </el-collapse-item>
          <el-collapse-item name="2">
            <template slot="title">
              <div class="coll-title">缴纳需知</div>
            </template>
            <div class="tip-item">1、如曾在单位参保，请您务必在办理截止日前确认上家单位已经停保，若未及时停保将导致业务无法办理成功。</div>
            <div class="tip-item">2、我们不承接正住院、患病、在校大学生及已怀孕等特殊人员的代缴服务，如隐瞒孕情、病情、学生身份下单，相应社保待遇将无法申请办理。</div>
            <div class="tip-item">3、我们提供社保公积金代缴服务，服务内容不包含劳动合同或涉及劳动关系证明的办理。</div>
            <div class="tip-item">4、如中途发起退款，可退未服务月的保费，服务费不退</div>
          </el-collapse-item>
          <el-collapse-item name="3">
            <template slot="title">
              <div class="coll-title">其他常见问题</div>
            </template>
            <div class="tip-item">1、我们的服务费包含哪些服务？我们的服务费用除了代办社保公积金服务，还免费附赠了价值1500元的增值服务，如社保卡办理、医疗保险报销、社保转入、公积金转入、社保信息修改等（具体可办理项根据当地政策情况来定），另外，您支付款项时的手续费（0.6%）也是由我们来承担的哦~所以服务费很划算呢！</div>
            <div class="tip-item">2、我们的代缴服务对用户年龄有限制吗？代缴服务对象年龄范围在男18周岁（含）-60周岁（含），女18周岁（含）-55周岁（含）</div>
            <div class="tip-item">3、下单后什么时候可以查询到参保成功？亲提交材料后，我们会帮您申报，因社保局/公积金中心存在审核期，一般次月中旬可查询到缴纳记录，个别城市税部门征缴机制延迟征收，也存在次次月中旬才可查询缴纳记录，但这并不影响当月正常申报的缴纳记录，所以还请耐心等待哦~</div>
            <div class="tip-item">4、在我们这里参保，社保卡、公积金卡等怎么办理？如首次在该城市参保，根据当地办理政策确定是否由我们代办，一般办理周期在2-6个月（因由当地政府部门制卡中心办理，只有社保局通知我们领卡，我们才能寄送给亲），具体请在支付完成后，点击“了解材料“，仔细阅读“温馨提醒”中的办卡流程哦~</div>
         </el-collapse-item>
        </el-collapse>
      </div>
      <el-tabs type="border-card" style="box-shadow: none;border-left: none;border-right: none" v-model="activeName">
        <el-tab-pane label="购物车" name="goodsCar">
          <social-order :payStatus="1" v-if="activeName === 'goodsCar'" @qrCodeEvent="qrCodeEvent"></social-order>
        </el-tab-pane>
        <el-tab-pane label="全部订单" name="payStatus0">
          <order :payStatus="0" v-if="activeName === 'payStatus0'" @qrCodeEvent="qrCodeEvent"></order>
        </el-tab-pane>
        <el-tab-pane label="未支付" name="payStatus1">
          <order :payStatus="1" v-if="activeName === 'payStatus1'" @qrCodeEvent="qrCodeEvent"></order>
        </el-tab-pane>
        <el-tab-pane label="已支付" name="payStatus2">
          <order :payStatus="2" v-if="activeName === 'payStatus2'"></order>
        </el-tab-pane>
        <el-tab-pane label=" 退款中" name="payStatus4">
          <order :payStatus="4" v-if="activeName === 'payStatus4'"></order>
        </el-tab-pane>
        <el-tab-pane label="已完成" name="payStatus3">
          <order :payStatus="3" v-if="activeName === 'payStatus3'"></order>
        </el-tab-pane>
      </el-tabs>
<!--      <div class="win-win" :style="win_winBG"></div>-->

      <div class="qr-code-dialog" v-if="qrCodeVisible">
        <el-dialog
          title="请用支付宝扫码支付"
          :visible.sync="qrCodeVisible"
          width="300px"
          :before-close="handleCloseQrCode">
          <pay-tool :qrCodeUri="qrCodeUri" ref="payToolRef"></pay-tool>
        </el-dialog>
      </div>

      <el-table
        v-if="false"
        :data="tableData"
        size="mini"
        header-cell-class-name="tb-header"
        stripe
        style="width: 100%">
        <el-table-column
          prop="city"
          label="城市"
          width="60">
        </el-table-column>
        <el-table-column
          prop="name"
          label="申请人姓名"
          width="80">
        </el-table-column>
        <el-table-column
          prop="idCard"
          label="身份证号码"
          width="180">
        </el-table-column>
        <el-table-column
          prop="phoneNum"
          label="手机号码"
          width="146">
        </el-table-column>
        <el-table-column
          prop="address"
          label="需代缴人户口所在地"
          width="146">
        </el-table-column>
        <el-table-column
          prop="registeredResidenceType"
          label="需代缴人户口性质"
          width="146">
        </el-table-column>
        <el-table-column
          prop="insuredBase"
          label="参保基数"
          width="126">
        </el-table-column>
        <el-table-column
          prop="initialInsuredMonth"
          label="初始参保月份"
          width="146">
        </el-table-column>
        <el-table-column
          prop="feePackage"
          label="参保服务费套餐"
          width="170">
        </el-table-column>
      </el-table>

      <el-drawer
        title="个人社保代缴申请"
        :visible.sync="drawer"
        :append-to-body="true"
        :size="'700px'"
        :custom-class="'person-data'"
        :before-close="handleClose">
        <div class="personal-input-box" v-if="!isAddFlag">
          <el-form :model="personalInputInfo" :rules="rules" ref="ruleForm" :size="'mini'" label-width="160px">
<!--          <el-form :model="personalInputInfo" ref="ruleForm" :size="'mini'" label-width="160px">-->
            <el-form-item label="缴纳城市" prop="city">
              <el-select v-model="personalInputInfo.city" placeholder="请选择缴纳城市" @change="citySelectChangeHandle">
                <!--              <el-option label="上海" value="上海"></el-option>-->
                <!--              <el-option label="深圳" value="深圳"></el-option>-->
                <el-option v-for="city of citiesArr" :key="city.id" :value="city.id" :label="city.city"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="申请人姓名" prop="name">
              <el-input v-model="personalInputInfo.name" placeholder="请输入申请人姓名"></el-input>
            </el-form-item>
            <el-form-item label="身份证号码" prop="idCard">
              <el-input v-model="personalInputInfo.idCard" placeholder="请输入身份证号码"></el-input>
            </el-form-item>
            <el-form-item label="身份证正面" prop="idCardFont">
              <el-upload
                :action="ID_CARD_URI"
                :headers="{'auth-user': $store.get('Authorization')}"
                list-type="picture-card"
                :on-preview="handlePreview"
                :on-success="handleSuccess1"
                :file-list="fileList1"
                :accept="'.jpg,.png'"
                :limit="1"
                :on-remove="handleRemove1">
                <div slot="tip" class="upload-mask">只能上传jpg/png文件，且不超过500M</div>
                <i class="el-icon-plus"></i>
              </el-upload>
              <!--            <div class="upload-mask"></div>-->
            </el-form-item>
            <el-form-item label="身份证反面" prop="idCardReverse">
              <el-upload
                :action="ID_CARD_URI"
                :headers="{'auth-user': $store.get('Authorization')}"
                list-type="picture-card"
                :on-preview="handlePreview"
                :on-success="handleSuccess2"
                :file-list="fileList2"
                :accept="'.jpg,.png'"
                :limit="1"
                :on-remove="handleRemove2">
                <div slot="tip" class="upload-mask">只能上传jpg/png文件，且不超过500M</div>
                <i class="el-icon-plus"></i>
              </el-upload>
              <!--            <div class="upload-mask"></div>-->
            </el-form-item>
            <el-form-item label="手机号码" prop="phoneNum">
              <el-input v-model="personalInputInfo.phoneNum" placeholder="请输入手机号码"></el-input>
<!--              <el-button :type="'primary'" @click="sendVerifiCode" v-if="!verifiCateIphoneFlag">发送验证码</el-button>-->
<!--              <el-button type="success" icon="el-icon-check" v-if="verifiCateIphoneFlag">验证成功</el-button>-->
            </el-form-item>
<!--            <div style="margin-left: 160px;margin-right:20px;margin-bottom: 20px">-->
<!--              <el-input v-model="verifiCateIphoneCode" placeholder="请输入验证码" v-if="!verifiCateIphoneFlag" size="mini" style="width: calc(100% - 120px)"></el-input>-->
<!--              <el-button :type="'primary'" @click="verifiCateIphone" v-if="!verifiCateIphoneFlag" size="mini">验&nbsp;证&nbsp;手&nbsp;机</el-button>-->
<!--            </div>-->
            <el-form-item label="需代缴人户口所在地" prop="registeredResidence">
              <el-input v-model="personalInputInfo.registeredResidence" placeholder="请输入需代缴人户口所在地"></el-input>
              <!--            <el-select v-model="personalInputInfo.registeredResidence" placeholder="请选择需代缴人户口所在地">-->
              <!--              <el-option label="上海" value="上海"></el-option>-->
              <!--              <el-option label="深圳" value="深圳"></el-option>-->
              <!--            </el-select>-->
            </el-form-item>
            <el-form-item label="需代缴人户口性质" prop="registeredResidenceType">
              <el-radio v-model="personalInputInfo.registeredResidenceType" label="城镇">城镇</el-radio>
              <el-radio v-model="personalInputInfo.registeredResidenceType" label="非城镇">非城镇</el-radio>
            </el-form-item>
            <el-form-item label="参保基数" prop="insuredBase">
              <el-input v-model="personalInputInfo.insuredBase" :placeholder="personalInputInfo.insuredBaseTip" @blur="getSocialSecurityPrice()"></el-input>
            </el-form-item>
            <el-form-item label="初始参保月份" prop="initialInsuredMonth">
              <el-date-picker
                v-model="personalInputInfo.initialInsuredMonth"
                type="month"
                placeholder="请选择初始参保月份">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="参保服务费套餐" prop="feePackage">
              <div v-for="(item) of personalInputInfo.feePackage" :key="item.id" class="fee-package">
                <div style="display: inline-block; width: 85px">{{item.title}}</div>
                <div style="display: inline-block; width: calc(100% - 90px)">
                  <span style="color: #fd5f39">￥{{item.unitPrice}}/月</span>
                  <span style="float: right"><el-input-number v-model="item.share" :step="1" :min="0" step-strictly></el-input-number></span>
                </div>
              </div>
            </el-form-item>
          </el-form>

          <el-dialog :visible.sync="picDialogVisible" :width="'600px'">
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>

          <div class="price-table">
            <div style="color: #fd5f39">所城市社保价格</div>
            <el-table
              :data="priceStaticsData"
              :span-method="arraySpanMethod"
              show-summary
              :size="'small'"
              :summary-method="getSummaries"
              border
              style="width: 100%">
              <el-table-column
                prop="id"
                label="缴纳项目"
                width="'16.66666%'">
                <el-table-column
                  prop="type"
                  label=""
                  width="80"
                  style="display: none">
                </el-table-column>
                <el-table-column
                  prop="contributedItems"
                  label=""
                  style="display: none">
                </el-table-column>
              </el-table-column>
              <el-table-column
                prop="proportion"
                label="企业比例"
                width="'16.66666%'">
              </el-table-column>
              <el-table-column
                prop="enterprisePension"
                label="企业金额(元)"
                width="'16.66666%'">
              </el-table-column>
              <el-table-column
                prop="personProportion"
                label="个人比例"
                width="'16.66666%'">
              </el-table-column>
              <el-table-column
                prop="personPension"
                label="个人金额(元)"
                width="'16.66666%'">
              </el-table-column>
              <el-table-column
                prop="subtotal"
                label="合计(元)"
                width="'16.66666%'">
              </el-table-column>
            </el-table>
          </div>

          <div style="padding: 0 10px">
            <div style="color: #fd5f39">服务费套餐明细</div>
            <table style="width: 100%">
              <tr>
                <td class="fee-package-title">商品名称</td>
                <td class="fee-package-num">数量</td>
                <td>小计</td>
              </tr>
              <tr v-for="item of personalInputInfo.feePackage" :key="item.id">
                <td class="fee-package-title">{{item.title}}</td>
                <td class="fee-package-num">x {{item.share}}</td>
                <td class="fee-package-total">￥{{(item.unitPrice * item.share).toFixed(2)}}</td>
              </tr>
            </table>
            <div style="text-align: center">总计<span style="color: #fd5f39; font-size: 20px">￥{{totalPay()}}</span></div>
            <div style="text-align: center;margin-top: 10px">
              <el-button :type="'primary'" @click="saveOrder()" :size="'small'">添加到购物车</el-button>
              <el-button :type="'primary'" @click="saveAndPayOrder()" :size="'small'">确认并支付</el-button>
            </div>
          </div>
        </div>
      </el-drawer>
    </div>
</template>

<script>
import Order from './Order'
import PayTool from '../PayTool/PayTool'
import SocialOrder from './SocialOrder'
import utilService from '../../utils/utilService'
export default {
  name: 'SocialSecurity',
  components: {SocialOrder, Order, PayTool},
  data () {
    let validateSyn = (rule, value, callback) => {
      this.utilService.checkSensitive({sensitive: value.trim()}, callback)
    }
    let validateIdCard = (rule, value, callback) => {
      if (this.utilService.isCardID(value.trim())) {
        callback()
      } else {
        callback(new Error('请填写正确的身份证号！'))
      }
    }
    let validatePhone = (rule, value, callback) => {
      if (this.utilService.isMobile(value.trim())) {
        callback()
      } else {
        callback(new Error('请填写正确的手机号！'))
      }
    }
    let validateNum = (rule, value, callback) => {
      if (parseInt(value.trim()) < this.personalInputInfo.lowM || parseInt(value.trim()) > this.personalInputInfo.heightM) {
        callback(new Error(this.personalInputInfo.insuredBaseTip))
      } else {
        callback()
      }
    }
    let validateFeePackage = (rule, value, callback) => {
      if (value.every(item => item.share === 0)) {
        callback(new Error('请至少选择一种服务套餐！'))
      } else {
        callback()
      }
    }
    return {
      utilService: utilService,
      activeNames: ['1'],
      tableData: [
        {
          city: '深圳',
          name: 'name',
          idCard: '532924202003255626',
          phoneNum: '13202290257',
          address: '深圳',
          registeredResidenceType: '非城镇',
          insuredBase: 5000,
          initialInsuredMonth: '2020-03-25',
          feePackage: '套餐一'
        }
      ],
      drawer: false,
      newInputInfo: null,
      personalInputInfo: {
        city: '',
        name: '',
        idCard: '',
        idCardFont: '',
        idCardReverse: '',
        phoneNum: '',
        registeredResidence: '',
        registeredResidenceType: '',
        insuredBase: '',
        insuredBaseTip: '请输填写参保基数，不同城市参保基数不同',
        lowM: 0,
        heightM: 0,
        initialInsuredMonth: '',
        feePackage: [
          {
            id: 'feePackage1',
            title: '6个月（总费用）',
            unitPrice: '180.00',
            share: 0
          },
          {
            id: 'feePackage2',
            title: '12个月（总费用）',
            unitPrice: '100.00',
            share: 0
          },
          {
            id: 'feePackage3',
            title: '24个月（总费用）',
            unitPrice: '30.00',
            share: 0
          }
        ]
      },
      rules: {
        city: {required: true, message: '请选择社保缴纳的城市', trigger: 'blur'},
        name: [{required: true, message: '请输入申请人姓名', trigger: 'blur'}, {validator: validateSyn, trigger: 'blur'}],
        idCard: [{required: true, message: '请输入身份证号码', trigger: 'blur'}, {validator: validateIdCard, trigger: 'blur'}],
        idCardFont: [{required: true, message: '请上传身份证正面照片', trigger: 'blur'}],
        idCardReverse: [{required: true, message: '请上传身份证反面照片', trigger: 'blur'}],
        phoneNum: [{required: true, message: '请输入手机号码', trigger: 'blur'}, {validator: validatePhone, trigger: 'blur'}],
        registeredResidence: [{required: true, message: '请输入需代缴人户口所在地', trigger: 'blur'}, {validator: validateSyn, trigger: 'blur'}],
        registeredResidenceType: {required: true, message: '请选择需代缴人户口性质', trigger: 'blur'},
        insuredBase: [{required: true, message: '请输入参保基数', trigger: 'blur'}, {validator: validateNum, trigger: 'blur'}],
        initialInsuredMonth: {required: true, message: '请选择初始参保月份', trigger: 'blur'},
        feePackage: [{validator: validateFeePackage}]
      },
      dialogImageUrl: '',
      fileList1: [],
      fileList2: [],
      qrCodeVisible: false,
      qrCodeUri: '',
      // qrCode: null,
      // stompClient: null,
      ID_CARD_URI: location.origin + '/recurit/document/upload/idCard?category=ID_CARD',
      picDialogVisible: false,
      verifiCateIphoneCode: '',
      verifiCateIphoneFlag: false,
      citiesArr: [],
      priceStaticsData: [],
      isAddFlag: false,
      activeName: 'goodsCar'
    }
  },
  methods: {
    handleChange (val) {
      console.log(val)
    },
    citySelectChangeHandle (e) {
      console.log(e)
      console.log(this.citiesArr)
      let city = this.citiesArr.filter(item => item.id === e)[0]
      this.personalInputInfo.lowM = (city.lowCardinality / 100).toFixed(2)
      this.personalInputInfo.heightM = (city.hightCardinality / 100).toFixed(2)

      this.personalInputInfo.insuredBaseTip = `请填写正确的参保基数，${city.city}的参保基数范围为${this.personalInputInfo.lowM} - ${this.personalInputInfo.heightM}元`
    },
    openDrawer () {
      this.drawer = true
      this.newInputInfo = {}
    },
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          console.log(this.editUserInfo)
          done()
        })
        .catch(_ => {})
    },
    handleRemove1 (file, fileList) {
      this.personalInputInfo.idCardFont = ''
    },
    handleRemove2 (file, fileList) {
      this.personalInputInfo.idCardReverse = ''
    },
    handlePreview (file) {
      this.dialogImageUrl = file.url
      this.picDialogVisible = true
    },
    handleSuccess1 (response, file, fileList) {
      console.log(response)
      if (response.code === 200 && response.data) {
        this.personalInputInfo.idCardFont = response.data.id
      }
    },
    handleSuccess2 (response, file, fileList) {
      console.log(response)
      if (response.code === 200 && response.data) {
        this.personalInputInfo.idCardReverse = response.data.id
      }
    },
    handleErrorUpload (err, file, fileList) {
      console.log(err)
    },
    totalPay () {
      let result = 0
      this.personalInputInfo.feePackage.forEach(item => {
        result += item.unitPrice * item.share
      })
      return result.toFixed(2)
    },
    getFeePackageIds () {
      let res = this.personalInputInfo.feePackage.map(item => {
        return {
          packageId: item.id,
          amount: item.share
        }
      }).filter(item => item.amount !== 0)
      console.log(this.personalInputInfo.feePackage)
      return JSON.stringify(res)
    },
    saveOrder () {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          const param = {
            applyName: this.personalInputInfo.name, // 申请人姓名
            cardinality: (this.personalInputInfo.insuredBase.trim()) * 100, // 基数
            cityId: this.personalInputInfo.city, // 社保所在城市
            domicile: this.personalInputInfo.registeredResidence, // 户籍所在地
            feePackageIds: this.getFeePackageIds(), // 套餐
            idCard: this.personalInputInfo.idCard, // 身份证号码
            natureRegist: this.personalInputInfo.registeredResidenceType, // 户籍性质
            phone: this.personalInputInfo.phoneNum, // 手机号码
            positiveIdCard: this.personalInputInfo.idCardFont, // 身份证正面
            reverseIdCard: this.personalInputInfo.idCardReverse, // 身份证反面
            socialSecurityDate: this.personalInputInfo.initialInsuredMonth.getTime() // 参保日期
          }
          this.$http.post(this.$api.saveSocialSecuritInfo.url, param).then(_ => {
            if (_ && _.code === 200) {
              this.$message.success('添加到购物车成功！')
              this.drawer = false
              this.activeName = ''
              this.activeName = 'goodsCar'
            }
            if (_ && _.code !== 200 && _.msg) {
              this.$message.error(_.msg)
            }
          })
        } else {
          return false
        }
      })
    },
    saveAndPayOrder () {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          const param = {
            subject: '上海仁格社保代缴业务',
            applyName: this.personalInputInfo.name, // 申请人姓名
            cardinality: (this.personalInputInfo.insuredBase.trim()) * 100, // 基数
            cityId: this.personalInputInfo.city, // 社保所在城市
            domicile: this.personalInputInfo.registeredResidence, // 户籍所在地
            feePackageIds: this.getFeePackageIds(), // 套餐
            idCard: this.personalInputInfo.idCard, // 身份证号码
            natureRegist: this.personalInputInfo.registeredResidenceType, // 户籍性质
            phone: '13202290257', // 手机号码
            positiveIdCard: this.personalInputInfo.idCardFont, // 身份证正面
            reverseIdCard: this.personalInputInfo.idCardReverse, // 身份证反面
            socialSecurityDate: this.personalInputInfo.initialInsuredMonth.getTime() // 参保日期
          }
          this.$http.post(this.$api.saveDirectSecuritInfo.url, param).then(_ => {
            if (_ && _.code !== 200 && _.msg) {
              this.$message.error(_.msg)
              return false
            }
            if (_ && _.code === 200 && _.data && _.data.qrCode) {
              this.drawer = false
              this.qrCodeVisible = true
              this.qrCodeUri = _.data.qrCode
            } else if (_ && !_.data.qrCode && _.data.subMsg) {
              this.$message.error(_.data.subMsg)
            }
          })
        } else {
          return false
        }
      })
    },
    // checkData () {
    //   if (!this.personalInputInfo.city) {
    //     return '请选择社保缴纳城市！'
    //   }
    //   if (!this.personalInputInfo.name) {
    //     return '请填写申请人姓名!'
    //   }
    //   if (!this.personalInputInfo.idCard) {
    //     return '请填写身份证号码!'
    //   }
    //   if (!utilService.isCardID(this.personalInputInfo.idCard)) {
    //     return '请填写正确的身份证号码!'
    //   }
    //   if (!this.personalInputInfo.idCardFont) {
    //     return '请上传身份证正面!'
    //   }
    //   if (!this.personalInputInfo.idCardReverse) {
    //     return '请上传身份证反面!'
    //   }
    //   if (!this.personalInputInfo.phoneNum) {
    //     return '请填写手机号码!'
    //   }
    //   if (!utilService.isMobile(this.personalInputInfo.phoneNum)) {
    //     return '请填写正确的手机号码!'
    //   }
    //   if (!this.personalInputInfo.registeredResidence) {
    //     return '请填写需代缴人户口所在地!'
    //   }
    //   if (!this.personalInputInfo.registeredResidenceType) {
    //     return '请选择需代缴人户口性质!'
    //   }
    //   if (!this.personalInputInfo.insuredBase ||
    //     parseInt(this.personalInputInfo.insuredBase.trim()) < this.personalInputInfo.lowM ||
    //     parseInt(this.personalInputInfo.insuredBase.trim()) > this.personalInputInfo.heightM) {
    //     return this.personalInputInfo.insuredBaseTip
    //   }
    //   if (!this.personalInputInfo.initialInsuredMonth) {
    //     return '请选择初始参保月份!'
    //   }
    //   if (this.personalInputInfo.feePackage.every(item => item.share === 0)) {
    //     return '请至少选择一种参保服务费套餐!'
    //   }
    // },
    handleCloseQrCode (done) {
      if (this.$refs.payToolRef.payRes.payStatusMsg !== '支付成功') {
        this.$confirm('还未支付，是否关闭？')
          .then(_ => {
            this.qrCodeUri = ''
            this.$refs.payToolRef.disConnectMQ()
            this.qrCodeVisible = false
            done()
          })
          .catch(_ => {
          })
      } else {
        // this.initData()
        done()
      }
    },
    getSocialSecurityPrice () {
      if (!this.personalInputInfo.city || !this.personalInputInfo.insuredBase.trim()) {
        return false
      }
      this.$http.post(this.$api.calculatePrice.url, {
        standardId: this.personalInputInfo.city,
        feePackageIds: this.getFeePackageIds(),
        cardinality: parseInt(this.personalInputInfo.insuredBase.trim()) * 100
      }).then(_ => {
        if (_ && _.code === 200) {
          this.priceStaticsData = []
          _.data.socialSecurity.forEach((item, index) => {
            if (index < 5) {
              this.priceStaticsData.push({
                type: '五险',
                contributedItems: item.contributedItems,
                proportion: `${(item.proportion / 100).toFixed(2)}%`,
                personProportion: `${(item.personProportion / 100).toFixed(2)}%`,
                enterprisePension: `${(item.enterprisePension / 100).toFixed(2)}`,
                personPension: `${(item.personPension / 100).toFixed(2)}`,
                subtotal: `${(item.subtotal / 100).toFixed(2)}`
              })
            }
            if (index === 5) {
              this.priceStaticsData.push({
                type: '其他',
                contributedItems: item.contributedItems,
                proportion: `${(item.proportion / 100).toFixed(2)}%`,
                personProportion: `${(item.personProportion / 100).toFixed(2)}%`,
                enterprisePension: `${(item.enterprisePension / 100).toFixed(2)}`,
                personPension: `${(item.personPension / 100).toFixed(2)}`,
                subtotal: `${(item.subtotal / 100).toFixed(2)}`
              })
            }
          })
        }
      })
    },
    arraySpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % 5 === 0) {
          return {
            rowspan: 5,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    getSummaries (params) {
      const { columns, data } = params
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '小计'
          return
        }
        const values = data.map(item => Number(item[column.property]))
        if (!values.every(value => isNaN(value)) && ([3, 5, 6].indexOf(index) > -1)) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
          sums[index] = sums[index].toFixed(2) + ' 元'
        } else {
          sums[index] = 'N/A'
        }
      })
      return sums
    },
    qrCodeEvent (e) {
      this.qrCodeUri = e
      this.qrCodeVisible = true
    }
  },
  created () {
    if (location.origin.includes('127.0.0.1') || location.origin.includes('localhost')) {
      this.ID_CARD_URI = location.origin + '/api/recurit/document/upload/idCard?category=ID_CARD'
    }

    for (let i = 0; i < 10; i++) {
      let item = Object.assign({}, this.tableData[0])
      item.name = item.name + i
      this.tableData.push(item)
    }

    this.$http.get(this.$api.getAllSocialStandard.url).then(_ => {
      if (_ && _.code === 200) {
        this.citiesArr = _.data || []
      }
    })

    this.$http.get(this.$api.getAllActivityPackage.url).then(_ => {
      if (_ && _.code === 200) {
        this.personalInputInfo.feePackage = _.data.reverse().map(item => {
          return {
            id: item.id,
            unitPrice: (item.price / 100).toFixed(2),
            title: item.servicePeriod,
            share: 0
          }
        })
      }
    })
  }
}
</script>

<style scoped>
.social-security-page {
  width: 1200px;
  margin: auto;
  background: #ffffff;
  min-height: calc(100vh - 90px);
  text-align: left;padding-bottom: 20px;
}
  .btn-group, .tips {
    padding: 10px;
  }
  .coll-title {
    color: #fd5f39;
    font-size: 16px;
  }
  /deep/ .el-collapse-item__header {
    height: 36px;
    line-height: 36px;
  }
/deep/ .el-collapse-item__content {
  padding-bottom: 0;
}
  .tip-item {
    color: #39f;
  }
  /deep/ .tb-header {
    background: #ccc;
    color: #444;
  }
  /deep/ .personal-input-box .el-form-item__content {
    width: calc(100% - 180px);
  }
/deep/ .personal-input-box .el-form-item__content .el-select {
  width: 100%;
}
  .fee-package {
    width: 90%;
    border: 1px solid #cccccc;
    padding: 10px;
    margin-bottom: 20px;
  }
  .fee-package-title {
    width: calc(100% - 220px)
  }
.fee-package-num {
  width: 100px;
}
.fee-package-total {
  width: 100px;
}
  .qr-code-box {
    width: 150px;
    height: 150px;
    margin: auto;
  }
  .id-card-upload {
    width: 300px;
  }
  .upload-mask {
    color: #fd5f39;
    position: absolute;
    width: 150px;
    height: 150px;
    background: #ffffff;
    top: 0;
    left: 155px;
  }
.price-table {
  padding: 0 10px;
}
  .price-table /deep/ table>thead>tr:last-child{
    display: none;
  }
   /deep/ .person-data .el-drawer__body{
    height: 0;
    overflow-y: scroll !important;
    overflow-x: hidden !important;
  }
  /deep/ .personal-input-box {
    padding-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/SocialSecurity/SocialSecurity.vue